export const lang: any = {
  get: (string: string, parameters: string[]) => {
    switch (string) {
      case 'MAX_ORDER_QUANTITY_REACHED_SUMMARY':
        return `Maksimi tilausmäärä saavutettu.`;
      case 'MAX_ORDER_QUANTITY_REACHED_DETAILS':
        return `Et voi tilata enempää kuin ${parameters && parameters.length > 0 ? parameters[0] : ''
          } yksikköä tästä tuotteesta.`;
      case 'YOU_CAN_ADD_MORE':
        return `Voit lisätä ${parameters[0]} lisää`;
      case 'QUANTITY_EXCEEDS_STOCK':
        return `Määrä ylittää varastossa olevan. Vain ${parameters && parameters.length > 0 ? parameters[0] : '0'} saatavilla.`;
      case 'ORDER_BEFORE_CUTOFF_AND_KITCHEN_PREPARES':
        return `Tilaa ennen klo ${parameters && parameters.length > 0 ? parameters[0] : ''}, niin saat aikaisemman toimituksen`;
      case 'ADDON_SHOW_MORE_COUNT':
        return `Näytä ${parameters?.[0] ?? ''} lisää`;
      case 'ADDON_SHOW_MORE_GROUPS_ONE':
        return `Näytä ${parameters?.[0] ?? ''} ryhmä lisää`;
      case 'ADDON_SHOW_MORE_GROUPS_MANY':
        return `Näytä ${parameters?.[0] ?? ''} ryhmää lisää`;
      case 'FIRST_AVAILABLE':
        return `Saatavilla aikaisintaan ${parameters && parameters.length > 0 ? parameters[0] : ''}`;
      case 'TODO_TODO':
        return `TODO`;
      default:
        return '';
    }
  },
  CORPORATE_CATERING: 'Yrityscatering',
  GO_TO_CHECKOUT: 'Siirry kassalle',
  FIRST_AVAILABLE: 'Saatavilla aikaisintaan',
  SELECT_PICKUP_DATE: 'Valitse noutopäivä',
  MAX_ORDER_QUANTITY_REACHED_SUMMARY: 'Maksimi tilausmäärä saavutettu.',
  MAX_ORDER_QUANTITY_REACHED_DETAILS: 'Et voi tilata enempää kuin sallittu määrä tästä tuotteesta.',
  ADD_TO_CART: 'Lisää koriin',
  MORE_INFO: 'Lisätietoja',
  COMPLETE_YOUR_ORDER: 'Viimeistele tilauksesi',
  CHECKOUT_SUBTITLE: 'Seuraa alla olevia vaiheita viimeistelläksesi ostoksesi',
  PICKUP_INSTRUCTIONS_LABEL: 'Nouto-ohjeet',
  DELIVERY: 'Toimitus',
  INFORMATION: 'Tiedot',
  SUMMARY: 'Yhteenveto',
  PAYMENT: 'Maksu',
  DELIVERY_DETAILS: 'Toimitusyksityiskohdat',
  CHOOSE_DELIVERY_METHOD_AND_TIME: 'Valitse toimitustapa, päivämäärä ja kellonaika',
  SELECTED_DELIVERY_METHOD: 'Valittu toimitusmenetelmä',
  PICKUP: 'Noutopäivä',
  COLLECT_FROM_LOCATION: 'Nouto paikan päältä',
  DELIVER_TO_ADDRESS: 'Toimitus osoitteeseesi',
  DELIVERY_LOCATION: 'Toimitusosoite',
  DELIVERY_LOCATION_PROMPT: 'Minne toimitamme tilauksesi?',
  SELECT_DELIVERY_LOCATION: 'Valitse toimitusosoite',
  CONNECTED_COMPANY: 'Yhdistetty yritys',
  LOCATIONS_NAME: 'Sijaintin nimi',
  STREET_ADDRESS: 'Katuosoite',
  CITY: 'Kaupunki',
  POSTAL_CODE: 'Postinumero',
  FLOOR: 'Kerros',
  DELIVERY_ROOM: 'Toimitushuone',
  DOOR_CODE: 'Ovipinkoodi',
  DATE_AND_TIME: 'Päivämäärä & kellonaika',
  PICKUP_DATE_AND_TIME: 'Noutopäivä ja -aika',
  DELIVERY_DATE_AND_TIME: 'Toimituspäivä ja -aika',
  SELECT_DATE: 'Valitse päivä',
  SELECT_TIME: 'Valitse aika',
  ADDITIONAL_INSTRUCTIONS: 'Lisäohjeet',
  COMMENT_TO_RESTAURANT: 'Kommentti ravintolalle',
  COMMENT_TO_RESTAURANT_PLACEHOLDER:
    'Onko sinulla jotain, josta haluat ilmoittaa?',
  CONTINUE_TO_INFORMATION: 'Jatka tiedot-vaiheeseen',
  CONTINUE_CHECKOUT: 'Jatka ostamista',
  YOUR_INFORMATION: 'Tietosi',
  CONTACT_BILLING_DETAILS: 'Yhteystiedot ja laskutustiedot',
  CONTACT_INFO: 'Yhteystiedot',
  CONTACT_INFO_DESCRIPTION:
    'Käytämme näitä tietoja ottaaksemme sinuun yhteyttä tilauksestasi.',
  FIRST_NAME: 'Etunimi',
  FIRST_NAME_REQUIRED: 'Etunimi on pakollinen.',
  LAST_NAME: 'Sukunimi',
  EMAIL_ADDRESS: 'Sähköpostiosoite',
  PHONE_NUMBER: 'Puhelinnumero',
  ADDITIONAL_INFORMATION: 'Lisätiedot',
  BACK: 'Takaisin',
  PREVIOUS: 'Edellinen',
  CONTINUE_TO_SUMMARY: 'Jatka yhteenvetoon',
  CONTINUE: 'Jatka',
  ORDER_SUMMARY: 'Tilauksen yhteenveto',
  ORDER_SUMMARY_SUBTOTAL: 'Tarkista tilauksesi yksityiskohdat',
  YOUR_ITEMS: 'Tuotteesi',
  YOUR_ORDER: 'Tilauksesi',
  CLOSE: 'Sulje',
  TOTAL_AMOUNT: 'Kokonaissumma',
  DELIVERY_INFORMATION: 'Toimitusyksityiskohdat',
  DELIVERY_METHOD: 'Toimitusmenetelmä',
  NAME: 'Nimi',
  CREATED: 'Luotu',
  EMAIL: 'Sähköposti',
  USER_ID: 'Käyttäjätunnus',
  PHONE: 'Puhelin',
  ADDRESS: 'Osoite',
  RESTAURANT_INFO: 'Ravintolan tiedot',
  COMPANY_NAME: 'Yrityksen nimi',
  PROCEED_TO_PAYMENT: 'Jatka maksamiseen',
  PAYMENT_METHOD: 'Maksutapa',
  SELECT_PAYMENT_METHOD: 'Valitse maksutapa',
  PAYMENT_METHOD_DESCRIPTION: 'Valitse haluamasi maksutapa',
  CREDIT_CARD: 'Luottokortti',
  CREDIT_CARD_DESCRIPTION: 'Maksa turvallisesti kortilla',
  INVOICE: 'Lasku',
  INVOICE_DESCRIPTION: 'Maksa myöhemmin laskulla',
  CASH: 'Käteinen',
  CASH_DESCRIPTION: 'Maksa noudossa/toimituksessa',
  CONFIRM_ORDER: 'Vahvista maksu',
  ORDER_PLACED: 'Tilaus tehty!',
  SUCCESS_TEXT_1:
    'Tilauksesi on tehty onnistuneesti. Lähetämme sinulle vahvistusviestin sähköpostitse pian.',
  SUCCESS_TEXT_2:
    'Kun olet suorittanut maksun, saat tilausvahvistuksen sähköpostitse. Tarkista sähköpostisi tulevien tilauspäivitysten vuoksi.',
  PAYMENT_REQUIRED: 'Maksu vaaditaan',
  INCOMPLETE_ORDER: 'Keskeneräinen tilaus',
  KEEP_SHOPPING: 'Jatka ostoksia',
  CANCEL_CHECKOUT_PROMPT: 'Haluatko varmasti peruuttaa kassan?',
  CONFIRMATION: 'Vahvistus',
  CANCEL: 'Peruuta',
  YES: 'Kyllä',
  TOTAL_PRICE_IS_0: 'Kokonaishinta on 0',
  PLEASE_ADD_ITEMS_TO_CART: 'Lisää tuotteita ostoskoriin',
  ITEM: 'Tuote',
  ITEMS: 'Tuotteet',
  EMPTY_CART: 'Ostoskorisi on tyhjä',
  ADD_SOME_ITEMS: 'Lisää tuotteita aloittaaksesi!',
  SHOPPING_CART: 'Ostoskori',
  CLEAR_CART: 'Tyhjennä ostoskori',
  CLOSE_CART: 'Sulje ostoskori',
  CLEAR_CART_WARNING: 'Haluatko varmasti tyhjentää ostoskorin?',
  CLEAR_CART_YES: 'Tyhjennä ostoskori',
  CLEAR_CART_NO: 'Älä tyhjennä ostoskoria',
  CART_ITEMS_NOT_AVAILABLE_FOR_SELECTED_DATE: 'Jotkut ostoskorisi tuotteet eivät ole valitulle toimituspäivälle. Voit poistaa ne itse tai jatkaa.',
  NOT_AVAILABLE_FOR_DATE: 'Ei saatavilla valittuna päivänä',
  CLEAR: 'Tyhjennä',
  SUBTOTAL: 'Välisumma',
  TOTAL_ITEMS: 'Tuotteita yhteensä',
  TOTAL: 'Yhteensä',
  VAT: 'ALV',
  CHECKOUT: 'Kassalle',
  CONTACT: 'Yhteystiedot',
  LOCATION: 'Sijainti',
  Mobile_Pay_DESCRIPTION: 'Maksa turvallisesti mobiilimaksulla',
  Mobile_Pay: 'MobilePay',
  CONTINUE_SHOPPING: 'Jatka ostoksia',
  QUANTITY: 'Määrä',
  LANGUAGE: 'Kieli',
  SELECT_LANGUAGE: 'Valitse kieli',
  CURRENT: 'Nykyinen',
  NO_LANGUAGES_FOUND: 'Kieliä ei löytynyt',
  TRY_DIFFERENT_SEARCH: 'Kokeile eri hakusanaa',
  CHOOSE_A_DATE: 'Valitse päivä',
  CHOOSE_A_TIME: 'Valitse aika',
  SELECT_PICKUP_TIME: 'Valitse noutoaika',
  COMPANY_NAME_OPTIONAL: 'Yrityksen nimi (valinnainen)',
  LOCATION_NAME_OPTIONAL: 'Sijaintin nimi (valinnainen)',
  ENTER_STREET_ADDRESS: 'Syötä katuosoite',
  ENTER_CITY: 'Syötä kaupunki',
  ENTER_POSTAL_CODE: 'Syötä postinumero',
  FLOOR_NUMBER_OPTIONAL: 'Kerrosnumero (valinnainen)',
  ROOM_NUMBER_OPTIONAL: 'Huonenumero (valinnainen)',
  ACCESS_CODE_OPTIONAL: 'Pääsykoodi (valinnainen)',
  ENTER_FIRST_NAME: 'Syötä etunimi',
  ENTER_LAST_NAME: 'Syötä sukunimi',
  ENTER_EMAIL: 'Syötä sähköpostiosoite',
  ENTER_ADDRESS: 'Syötä osoite',
  EMAIL_REQUIRED: 'Sähköpostiosoite on pakollinen.',
  EMAIL_INVALID: 'Syötä voimassa oleva sähköpostiosoite.',
  SUCCESS: 'Onnistui',
  ERROR: 'Virhe',
  SAVING: 'Tallennetaan…',
  SET_PASSWORD_TITLE: 'Aseta salasanasi',
  SET_PASSWORD_FOR_ACCOUNT: 'Tilille:',
  SET_PASSWORD_SUBTITLE: 'Aseta uusi salasana tilillesi.',
  NEW_PASSWORD: 'Uusi salasana',
  CONFIRM_NEW_PASSWORD: 'Vahvista uusi salasana',
  SAVE_PASSWORD: 'Tallenna salasana',
  PROCESSING_LINK: 'Käsitellään linkkiä…',
  RESET_LINK_INVALID: 'Salasanan palautuslinkki on virheellinen tai vanhentunut.',
  FILL_BOTH_PASSWORD_FIELDS: 'Täytä molemmat salasanakentät.',
  PASSWORDS_DO_NOT_MATCH: 'Salasanat eivät täsmää.',
  PASSWORD_TOO_SHORT: 'Salasanan tulee olla vähintään 6 merkkiä.',
  PASSWORD_RESET_SUCCESS: 'Salasana on nollattu onnistuneesti.',
  PASSWORD_RESET_FAILED: 'Salasanan nollaus epäonnistui. Yritä uudelleen.',
  LOGIN_SUCCESS: 'Olet nyt kirjautunut sisään.',
  DELIVERY_OPTIONS_UNLOCKED: 'Toimitusvaihtoehdot ovat nyt käytettävissä.',
  LOGIN_INVALID_CREDENTIALS: 'Virheellinen sähköposti tai salasana.',
  AUTH_EMAIL_MISSING_AT: "Lisää '@' sähköpostiosoitteeseen.",
  LOGIN_FAILED: 'Kirjautuminen epäonnistui. Yritä uudelleen.',
  ACCOUNT_CREATED_SUCCESS: 'Tili luotu onnistuneesti.',
  ACCOUNT_CREATED_FAILED: 'Tilin luominen epäonnistui.',
  ACCOUNT_ALREADY_EXISTS_ON_THIS_MAIL: 'Tilillä on jo sähköposti käytössä.',
  OKAY: 'Selvä',
  ADD_TO_CART_HEADER: 'Lisää ostoskoriin',
  PER_UNIT: 'per yksikkö',
  QUANTITY_LABEL: 'Määrä (min. {{min}})',
  MIN_ORDER_QUANTITY: 'Vähimmäistilausmäärä',
  MAX_ORDER_QUANTITY: 'Enimmäistilausmäärä',
  UNITS: 'kpl',
  PICKUP_TIME: 'Noutoaika',
  DELIVERY_TIME: 'Toimitusaika',
  DELIVERY_DATE: 'Toimituspäivä',
  PICKUP_DATE: 'Noutopäivä',
  ORDER_TYPE: 'Tilaustyyppi',
  HOME_DATE_SELECTION_UNAVAILABLE_TITLE: 'Palvelutapoja ei ole saatavilla',
  HOME_DATE_SELECTION_UNAVAILABLE_DESCRIPTION: 'Tämä ravintola ei tällä hetkellä ota vastaan nouto- tai toimitustilauksia.',
  HOME_DATE_SELECTION_UNAVAILABLE_NOTE: 'Ei ota tilauksia juuri nyt',
  SELECT_DELIVERY_DATE: 'Valitse toimituspäivä',
  SELECT_DELIVERY_AND_DATE: 'Toimitus ja päivämäärä',
  SELECT_ORDER_DATE: 'Toimitustapa ja päivämäärä',
  CONTINUE_WITHOUT_DATE: 'Jatka ilman päivämäärää',
  SELECT_WEEKDAY: 'Valitse nouto tai yritystoimitus ja valitse haluamasi päivämäärä',
  JUST_BROWSING: 'Selaan vain',
  CONFIRM: 'Vahvista',
  PRICE: 'Hinta',
  PRODUCT_DESCRIPTION: 'Tuotteen kuvaus',
  READ_MORE: 'Lue lisää',
  READ_LESS: 'Lue vähemmän',
  SERVINGS_PER_PRODUCT: 'Annokset per tuote',
  RETURN_TO_HOME: 'Palaa etusivulle',
  ORDER_FAILED: 'Tilaus epäonnistui',
  MAXIMUM_ORDER_QUANTITY: 'Maksimi',
  MINIMUM_ORDER_QUANTITY: 'Minimi',
  LOCATION_FOOTER: 'Osoite',
  INFO_FOOTER: 'Lisätietoja',
  HOSTED_BY_PUBQ: 'Palvelun tarjoaa PubQ AB',
  TERMS_OF_SERVICE: 'Palveluehdot',
  NO_PRODUCTS_AVAILABLE: 'Ei tuotteita saatavilla',
  CHECK_BACK_SOON_CATEGORY:
    'Tarkista pian uudelleen tämän kategorian uudet tuotteet',
  NO_CATEGORIES_AVAILABLE: 'Luokkia ei ole saatavilla',
  CHECK_BACK_LATER: 'Palaa myöhemmin päivityksiä varten!',
  NO_MENU_AVAILABLE: 'Ruokalista ei ole saatavilla',
  MENU_UPDATING_MESSAGE:
    'Päivitämme parhaillaan ruokalistaamme. Palaa pian herkullisten vaihtoehtojen pariin!',
  REFRESH_PAGE: 'Päivitä sivu',
  CONTACT_US: 'Ota yhteyttä',
  READ_TERMS: 'Olen lukenut käyttöehdot',
  ACCEPT_PURCHASE_TERMS_PREFIX: 'Viimeistelemällä tämän oston hyväksyt ',
  TERMS_AND_CONDITIONS: 'käyttöehdot',
  ACCEPT_PURCHASE_TERMS_AND: ' ja ',
  PRIVACY_POLICY: 'tietosuojakäytännön',
  NO_PRODUCTS_IN_CATEGORY: 'Ei tuotteita tässä kategoriassa',
  NO_PRODUCTS_MATCH_FILTERS: 'Mikään tuote ei vastaa valittuja suodattimia.',
  PRODUCTS_COMING_SOON: 'Tuotteita tulossa pian!',
  TIME_SLOT_NOT_SELECTED: 'Aikaväliä ei ole valittu',
  SEE_MORE: 'Lisätietoja',
  SOON_BACK_IN_STOCK: 'Tulossa pian takaisin',
  FEW_LEFT_IN_STOCK: 'Vähän jäljellä varastossa',
  OUT_OF_STOCK: 'Loppu varastosta',
  QUANTITY_EXCEEDS_STOCK: 'Määrä ylittää varastossa olevan. Vain {{0}} saatavilla.',
  INACTIVE: 'Ei aktiivinen',
  CURRENTLY_UNAVAILABLE: 'Tällä hetkellä ei saatavilla',
  PREPARATION_DAYS_REQUIRED: 'Valmistusaikaa vaaditaan',
  DAYS: 'Päivää',
  AVAILABLE: 'Saatavilla',
  AVAILABLE_PICKUP_DATES: 'Saatavilla olevat noutoaikavälit',
  CONTENTS_AND_ALLERGENS: 'Ainekset ja allergiat',
  SIMILAR_PRODUCTS: 'Samankaltaiset tuotteet',
  MILK: '🥛 Maito',
  MILK_PROTEIN: '🥛 Maitoproteiini',
  GLUTEN: '🌾 Gluteeni',
  NUTS: '🥜 Pähkinät',
  CRUSTACEANS: '🦞 Äyriäiset',
  EGG: '🥚 Kananmuna',
  MOLLUSCS: '🦪 Nilviäiset',
  FISH: '🐟 Kala',
  PORK: '🥓 Sianliha',
  PEANUTS: '🥜 Maapähkinät',
  SESAME_SEEDS: '🌱 Seesaminsiemenet',
  SULPHUR: '🔥 Rikkiyhdisteet',
  SOYBEANS: '🫘 Soijapavut',
  CELERY: '🥬 Selleri',
  MUSTARD: '🌶️ Sinappi',
  LUPIN: '🌱 Lupiinipavut',
  GARLIC: '🧄 Valkosipuli',
  MUSHROOM: '🍄‍🟫 Sieni',
  ALMOND: '🥜 Manteli',
  HAZELNUT: '🥜 Hasselpähkinä',
  WALNUT: '🥜 Saksanpähkinä',
  CASHEW: '🥜 Cashewpähkinä',
  PECAN: '🥜 Pecanpähkinä',
  BRAZIL_NUT: '🥜 Paranpähkinä',
  PISTACHIO: '🥜 Pistaasipähkinä',
  MACADAMIA: '🥜 Macadamiapähkinä',
  DESCRIPTION: 'Kuvaus',
  ADDONS: 'Lisäosat',
  ADDON_PICK_ONE: 'Valitse yksi',
  ADDON_REQUIRED: 'Pakollinen',
  ADDON_OPTIONAL: 'Valinnainen',
  ADDON_MIN: 'Min',
  ADDON_MAX: 'Max',
  ADDON_UNAVAILABLE: 'Ei saatavilla',
  ADDON_SHOW_LESS: 'Näytä vähemmän',
  ADDON_SHOW_FEWER_GROUPS: 'Näytä vähemmän ryhmiä',
  // Success page translations
  ORDER_CONFIRMED: 'Tilaus vahvistettu!',
  ORDER_NUMBER_LABEL: 'Tilaus #',
  PAYMENT_PROCESSED: 'Maksu käsitelty',
  PAYMENT_CONFIRMED: 'Maksusi on vahvistettu',
  EMAIL_SENT: 'Sähköposti lähetetty',
  EMAIL_CONFIRMATION_SENT: 'Vahvistus lähetetty postilaatikkoosi',
  ORDER_PROCESSING: 'Tilaus käsitellään',
  ORDER_PREPARING: 'Ravintola valmistelee tilauksesi',
  BACK_TO_HOME: 'Palaa etusivulle',
  // Failure page translations
  PAYMENT_FAILED: 'Maksu epäonnistui',
  PAYMENT_DECLINED: 'Maksu hylätty',
  PAYMENT_METHOD_DECLINED: 'Maksutapasi hylättiin',
  WHAT_TO_DO_NEXT: 'Mitä tehdä seuraavaksi?',
  VERIFY_PAYMENT_AND_RETRY: 'Tarkista maksutietosi ja yritä uudelleen',
  HOME: 'Etusivu',
  MAXIMUM_REACHED: 'Maksimi saavutettu',
  SEARCH_TEXT: 'Hae...',
  IMPORTANT_INFORMATION: 'Tärkeää tietoa',
  DIFFERENT_PRODUCTION_TIMES_WARNING: 'Aikaisin toimituspäivä määräytyy pisimmän tuotantoajan omaavan tuotteen perusteella.',
  GOOGLE_PAY: 'Google Pay',
  GOOGLE_PAY_DESCRIPTION: 'Maksa turvallisesti Google Paylla',
  APPLE_PAY: 'Apple Pay',
  APPLE_PAY_DESCRIPTION: 'Maksa turvallisesti Apple Paylla',
  SWISH: 'Swish',
  SWISH_DESCRIPTION: 'Maksa turvallisesti Swishillä',
  COMPLETE_SWISH_PAYMENT: 'Viimeistele Swish-maksu',
  SELECT_WHERE_TO_OPEN_SWISH: 'Valitse mistä avaat Swishin',
  LAUNCHES_SWISH_APP: 'Käynnistää Swish-sovelluksen',
  SCAN_QR_CODE: 'Skannaa QR-koodi',
  CANCEL_PAYMENT: 'Peruuta maksu',
  // Swish payment component
  SWISH_CHOOSE_HOW_TO_PAY: 'Valitse maksutapa',
  SWISH_SUBTITLE: 'Käytä Swishiä tällä laitteella tai toisella laitteella.',
  SWISH_PAY_ON_THIS_DEVICE: 'Maksa tällä laitteella',
  SWISH_PAY_ON_OTHER_DEVICE: 'Maksa toisella laitteella',
  SWISH_SCAN_QR_CODE: 'Skannaa QR-koodi Swishillä maksaaksesi',
  PAYMENT_DEVICE_NOT_SUPPORTED: 'Tämä laite ei tue Swish-maksuja',
  SWISH_OPEN_ON_PHONE: 'Avaa Swish puhelimellasi maksaaksesi',
  SWISH_OPEN_APP: 'Avaa Swish',
  SWISH_PAYMENT_SUCCESS: 'Maksu onnistui',
  SWISH_PAYMENT_FAILED: 'Maksu epäonnistui',
  SWISH_PAYMENT_ERROR: 'Virhe maksun käsittelyssä.',
  SWISH_PAYMENT_CANCELLED_INFO:
    'Maksu peruutettiin Swishissä. Muuta tilausta tarvittaessa ja käytä sitten samaa Swish-painiketta uuden QR-koodin saamiseksi.',
  SWISH_VERIFY_TIMEOUT: 'Swish-maksu aikakatkaistiin',
  BACK_TO_CHECKOUT: 'Takaisin kassalle',
  EARLIEST_DELIVERY_DATE: 'Varhaisin toimituspäivä',
  EARLIEST_POSSIBLE_DELIVERY_DATE_IS: 'Aikaisin toimituspäivä',
  AVAILABLE_FROM: 'Saatavilla',
  DELIVER: 'Toimitus',
  DELIVERY_LOCATIONS: 'Toimituspaikat',
  CORPORATE_DELIVERY_LOCATIONS: 'Yrityksen toimituspaikat',
  NO_CORPORATE_CUSTOMERS: 'Yritysasiakkaita ei ole saatavilla',
  COMPANY: 'Yritys',
  ENTRANCE_CODE: 'Pääsykoodi',
  DEFAULT_REFERENCE: 'Oletusviite',
  SPECIFIC_LOCATION: 'Erityinen sijainti',
  SELECT_LOCATION: 'Valitse paikka',
  VIEW_ALL_DELIVERY_LOCATIONS: 'Näytä kaikki toimituspaikat',
  CHANGE: 'Vaihda',
  SELECT: 'Valitse',
  INVOICE_INFORMATION: 'Laskutusosoite',
  INVOICE_ADDRESS: 'Laskutusosoite',
  ORGANIZATION_NUMBER: 'Organisaation numero',
  VAT_NUMBER: 'Maksutapahtuman numero',
  COST_CENTER: 'Kustannuspaikka',
  SELECT_DELIVERY_TIME: 'Valitse toimitusaika',
  // Login dialog
  LOGIN_TO_YOUR_ACCOUNT: 'Kirjaudu tilillesi',
  LOGIN_SUBTITLE: 'Kirjaudu sisään hallitaksesi catering-tilauksiasi ja saadaksesi pääsyn yrityscateringiin',
  LOGIN_EMAIL_PLACEHOLDER: 'example@email.com',
  PASSWORD: 'Salasana',
  FORGOT_PASSWORD: 'Unohtuiko salasana?',
  LOGIN_PASSWORD_PLACEHOLDER: 'Syötä salasanasi',
  LOGIN: 'Kirjaudu sisään',
  CREATE_NEW_ACCOUNT: 'Luo uusi tili',
  OR_CONTINUE_WITH: 'Tai jatka',
  CONTINUE_WITH_GOOGLE: 'Jatka Googlella',
  CONTINUE_WITH_MICROSOFT: 'Jatka Microsoftilla',
  CONTINUE_WITH_APPLE: 'Jatka Applella',
  CREATE_YOUR_ACCOUNT: 'Luo tilisi',
  CREATE_ACCOUNT_SUBTITLE: 'Rekisteröidy käyttääksesi yrityksen toimitusvaihtoehtoja',
  BACK_TO_LOGIN: 'Takaisin kirjautumiseen',
  CONFIRM_PASSWORD: 'Vahvista salasana',
  PASSWORD_REQUIREMENTS: 'Salasanan tulee olla vähintään 6 merkkiä.',
  CREATE_ACCOUNT: 'Luo tili',
  OR_SIGN_UP_WITH: 'Tai rekisteröidy',
  BACK_TO_STORE: 'Takaisin kauppaan',
  MY_ACCOUNT: 'Oma tili',
  MY_PAGE: 'Oma sivu',
  ACCOUNT_INFORMATION: 'Omat tiedot',
  EDIT: 'Muokkaa',
  ADD: 'Lisää',
  LOGOUT: 'Kirjaudu ulos',
  LOGOUT_SUCCESS: 'Uloskirjautuminen onnistui.',
  ACTIVE_ORDERS: 'Aktiiviset tilaukset',
  PREVIOUS_ORDERS: 'Aiemmat tilaukset',
  ORDER_STATUS: 'Tila',
  ORDER_NUMBER: 'Tilaus',
  DECLINED: 'Hylätty',
  COMPLETED: 'Valmis',
  DONE: 'Valmis',
  RECEIPTS: 'Kuittit',
  NO_ORDERS_YET: 'Ei tilauksia vielä',
  NO_ACTIVE_ORDERS_YET: 'Ei aktiivisia tilauksia',
  NO_ACTIVE_ORDERS_SUBTITLE: 'Tilauksesi näkyvät täällä valmistelun aikana.',
  NO_PREVIOUS_ORDERS_YET: 'Ei aiemmia tilauksia',
  NO_PREVIOUS_ORDERS_SUBTITLE: 'Viime kuun valmistuneet tai hylätyt tilaukset näkyvät täällä.',
  NO_RECEIPTS_YET: 'Ei kuitteja vielä',
  NO_RECEIPTS_SUBTITLE: 'Tilaustesi kuitit näkyvät täällä.',
  NO_CORPORATE_COMPANY_CONNECTED: 'Ei yritystä kytkettynä',
  NO_CORPORATE_COMPANY_SUBTITLE: 'Kytke yritystili tilataaksesi toimituksen työpaikallesi.',
  WANT_DELIVERY_TO_YOUR_COMPANY: 'Haluatko toimitus yrityksellesi?',
  DELIVERY_TO_COMPANY: 'Yritystoimitus',
  DELIVERY_NOT_AVAILABLE_NO_COMPANY: 'Toimitus ei käytettävissä',
  DELIVERY_NOT_AVAILABLE_NO_COMPANY_DESCRIPTION: 'Et ole oikeutettu yrityscateringiin',
  NO_SERVING_METHODS_AVAILABLE: 'Palvelutapoja ei ole saatavilla',
  NO_SERVING_METHODS_AVAILABLE_DESCRIPTION: 'Tämä ravintola ei tällä hetkellä ota vastaan nouto- tai toimitustilauksia.',
  CREATE_ACCOUNT_OR_LOGIN: 'Luo tili tai kirjaudu sisään',
  ENTER_PHONE: 'Syötä puhelinnumero',
  CURRENT_PASSWORD: 'Nykyinen salasana',
  ENTER_CURRENT_PASSWORD: 'Syötä nykyinen salasana',
  SAVE: 'Tallenna',
  // Account receipts
  CLIENT_INFORMATION: 'Asiakastiedot',
  VAT_ID: 'ALV-tunnus',
  RECEIPT: 'Kuitti',
  RECEIPT_NUMBER: 'Kuittinumero',
  DATE: 'Päivämäärä',
  PRODUCTS: 'Tuotteet',
  PRODUCT: 'Tuote',
  DISCOUNT: 'Alennus',
  // Forgot password page
  FORGOT_PASSWORD_TITLE: 'Unohditko salasanasi?',
  FORGOT_PASSWORD_SUBTITLE: 'Anna sähköpostiosoitteesi saadaksesi salasanan palautuslinkin.',
  FORGOT_PASSWORD_EMAIL_PLACEHOLDER: 'Syötä sähköpostiosoitteesi',
  FORGOT_PASSWORD_SUBMIT: 'Lähetä nollauslinkki',
  FORGOT_PASSWORD_BACK: 'Takaisin kirjautumiseen',
  FORGOT_PASSWORD_EMAIL_SENT: 'Salasanan nollauslinkki on lähetetty sähköpostiisi.',
  FORGOT_PASSWORD_FAILED: 'Nollaussähköpostin lähetys epäonnistui. Yritä uudelleen.',
  FORGOT_PASSWORD_INVALID_EMAIL: 'Syötä kelvollinen sähköpostiosoite.',
  GO_BACK: 'Takaisin',
  SUBMIT: 'Lähetä',
  //Home-panel translations
  CATEGORIES: 'Kategoriat',
  DIETARY_OPTIONS: 'Dieettivalinnat',
  SAVED_CARDS: 'Tallennetut kortit',
  COMING_SOON: 'Tulossa pian',
  ORDERS: 'Tilaukset',
  SHOW_MORE: 'Näytä lisää',
  SHOW_LESS: 'Näytä vähemmän',
  APPLY_FILTER: 'Käytä suodatinta',
  START_DATE: 'Alkupäivä',
  END_DATE: 'Loppupäivä',
  FILTER_RESULT: 'Suodattimen tulos',
  TOTAL_ACTIVE_ORDERS: 'Aktiivisten tilausten yhteensä',
  TOTAL_PREVIOUS_ORDERS: 'Aikaisempien tilausten yhteensä',
  TOTAL_SAVED_RECEIPTS: 'Tallennettujen kuittien yhteensä',
  CARD_DETAILS: 'Korttitiedot',
  ALL: 'Kaikki',
  CARD: 'Kortti',
  REMOVE_CARD: 'Poista kortti',
  REMOVE_CARD_TITLE: 'Poistetaanko tallennettu kortti?',
  REMOVE_CARD_WARNING: 'Tämä kortti poistetaan pysyvästi kaikista PubQ-järjestelmistä — mukaan lukien mobiilisovellus, verkkopalvelu ja kaikki muut PubQ-alustat. Tätä toimintoa ei voi kumota.',
  REMOVE_CARD_CONFIRM: 'Kyllä, poista kortti',
  REMOVE_CARD_FAILED: 'Kortin poistaminen epäonnistui. Yritä uudelleen.',
  REMOVING_CARD: 'Poistetaan…',
  SELECT_BOTH_START_END_DATES: 'Valitse sekä aloitus- että lopetuspäivä.',
  START_DATE_MUST_BE_BEFORE_END_DATE: 'Aloituspäivän on oltava ennen lopetuspäivää.',
  CATERING_PENDING: 'Odottaa',
  APPROVED: 'Hyväksytty',
  COUPON: 'Alennukset',
  APPLY_DISCOUNT: 'Käytä alennusta',
  COUPON_CODE: 'Alennuskoodi',
  HAVE_A_COUPON_CODE: 'Onko teillä alennuskoodi?',
  USE_COUPON_CODE: 'Käytä alennuskoodiasi',
  ENTER_YOUR_CODE_BELOW: 'Anna koodi alla',
  ENTER_YOUR_CODE_HERE: 'Anna koodi',
  APPLY: 'Käytä',
  REMOVE: 'Poista',
  TOTAL_DISCOUNT: 'Alennus yhteensä',
  INVALID_COUPON: 'Virheellinen koodi',
  CHECKING_DISCOUNT_CODE: 'Tarkistetaan koodia…',
  APPLIED_DISCOUNT: 'Alennus käytössä',
  UNEXPECTED_ERROR: 'Tapahtui odottamaton virhe.',
  UNEXPECTED_ERROR_TRY_AGAIN: 'Tapahtui odottamaton virhe. Yritä uudelleen.',
  PLEASE_FILL_REQUIRED_FIELDS: 'Täytä kaikki pakolliset kentät',
  EACH: 'kpl',
  TOTAL_ITEMS_PRODUCT_PAGE: 'Tuotemäärä',
  ONLY_ONE_SERVING_METHOD_AVAILABLE: 'Päivämäärän valinta',
  SELECT_WEEKDAY_SINGLE_METHOD: 'Milloin haluat vastaanottaa tilauksesi?',
  POWERED_BY: 'Palvelun tarjoaa',
  FROM: 'Alkaen',
  EX_VAT: 'alv 0 %',
  OF_WHICH_VAT: 'sis. alv',
  VAT_AMOUNT: 'ALV',
  TOTAL_INC_VAT: 'Yhteensä sis. alv',
  NO_COST: 'Ei lisäkustannuksia',

  // --- Guest "order by invoice" checkout (no login) ---
  GUEST_INVOICE_TITLE: "Tilaa laskulla",
  DELIVERY_GUEST_INVOICE: "Toimitus / tilaa laskulla",
  GUEST_INVOICE_DESCRIPTION: "Ei tarvetta kirjautua — laskutamme yritystäsi",
  GUEST_INVOICE_EVENT_SECTION: "Tilaisuuden tiedot",
  GUEST_INVOICE_EVENT_SECTION_DESCRIPTION: "Kerro, mihin tilaisuuteen tarjoilut tulevat.",
  GUEST_INVOICE_BILLING_SECTION: "Yrityksen ja laskutuksen tiedot",
  GUEST_INVOICE_BILLING_SECTION_DESCRIPTION: "Lasku lähetetään näihin tietoihin. Maksua ei veloiteta nyt.",
  MEETING_ROOM_NAME: "Neuvotteluhuoneen nimi",
  MEETING_ROOM_NAME_PLACEHOLDER: "esim. Neuvotteluhuone Aurora",
  NUMBER_OF_ATTENDEES: "Henkilömäärä",
  EVENT_HOST: "Tilaisuuden isäntä/emäntä",
  EVENT_END_TIME: "Tilaisuus päättyy (valinnainen)",
  SPECIAL_DIETS: "Erikoisruokavaliot",
  SPECIAL_DIETS_PLACEHOLDER: "esim. 2 gluteenitonta, 1 vegaani",
  PARTICIPANT_LIST: "Osallistujalista",
  PARTICIPANT_LIST_PLACEHOLDER: "Osallistujien nimet (valinnainen)",
  INVOICE_REFERENCE: "Viitetiedot",
  INVOICE_REFERENCE_PLACEHOLDER: "esim. projekti- tai viitenumero",
  INVOICE_EMAIL: "Laskutussähköposti",
  INVOICE_NO_PAYMENT_TAKEN: "Maksua ei veloitettu",
  INVOICE_WILL_FOLLOW: "Mitään ei ole veloitettu. Lasku lähetetään antamiisi laskutustietoihin.",
  ORDER_TERMS_TITLE: "Tilausehdot",
  ORDER_TERMS_BODY: "Tilaus on sitova. Muutokset ja peruutukset on tehtävä viimeistään kaksi (2) arkipäivää ennen tilaisuutta; myöhemmin tehdyt peruutukset laskutetaan täysimääräisinä. Tilauksen yhteydessä vahvistettu henkilömäärä on laskutuksen peruste. Maksuehto 14 vrk netto.",

  // --- Partner group restaurant picker (/g/:slug) ---
  PARTNER_CHOOSE_RESTAURANT: "Valitse ravintola",
  PARTNER_CHOOSE_RESTAURANT_HINT: "Valitse, mistä haluat tilata tarjoilut.",
  PARTNER_ORDER_FROM_HERE: "Tilaa",
  PARTNER_GROUP_NOT_FOUND: "Sivua ei löytynyt",
  PARTNER_GROUP_NOT_FOUND_DESCRIPTION: "Tämä ravintolaryhmän linkki ei ole käytettävissä. Tarkista linkki ja yritä uudelleen.",
};
